export default __webpack_public_path__ + "static/media/GOOGLE_SERVICE.0f2fb3eb.jpg";